<template>
  <div class="vimeo-controls">
    <play-layout :is-playing="isPlaying" :show-play="showPlay" @handleAction="handleAction"/>
    <div v-if="showControls" class="play-bar" >
      <div class="play-bar__top">
        <progress-bar :buffer="buffer" :progress="progress" :duration="duration" @seek="seek"/>
      </div>
      <div class="play-bar__bottom">
        <div class="play-bar__bottom--left">
          <play-pause-control :is-playing="isPlaying" @handleAction="handleAction"/>
          <time-stamp :time="time" :video-duration="duration"/>
        </div>
        <div class="play-bar__bottom--right">
          <volume :is-muted="isMuted" @unmute="unmute" @mute="mute"/>
          <full-screen v-if="supportFullScreen" :is-full-screen="isFullScreen" @minimize="minimize" @expand="expand"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PlayPauseControl from './play-pause'
import Volume from './volume'
import FullScreen from './fullscreen'
import TimeStamp from './time-stamp'
import ProgressBar from './progress'
import PlayLayout from './play-layout'

export default {
  name: 'VimeoCustomConrols',
  components: {
    TimeStamp,
    PlayPauseControl,
    Volume,
    FullScreen,
    ProgressBar,
    PlayLayout
  },
  props: {
    showControls: {
      type: Boolean,
      require: true
    },
    supportFullScreen: {
      type: Boolean
    },
    isPlaying: {
      type: Boolean,
      require: true
    },
    showPlay: {
      type: Boolean,
      require: true
    },
    isMuted: {
      type: Boolean,
      require: true
    },
    time: {
      type: Number,
      require: true
    },
    duration: {
      type: Number,
      require: true
    },
    isFullScreen: {
      type: Boolean,
      require: true
    },
    buffer: {
      type: Number,
      default: 0
    },
    progress: {
      type: Number,
      default: 0
    }
  },
  methods: {
    handleAction () {
      this.$emit('handleAction')
    },
    play () {
      this.$emit('play')
    },
    pause () {
      this.$emit('pause')
    },
    mute () {
      this.$emit('mute')
    },
    unmute () {
      this.$emit('unmute')
    },
    minimize () {
      this.$emit('minimize')
    },
    expand () {
      this.$emit('expand')
    },
    seek (time) {
      this.$emit('seek', time)
    }
  }
}
</script>

<style lang="scss" scoped>
.vimeo-controls {
  display: block;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.play-bar {
  width: 100%;
  position: absolute;
  bottom: 0;

  &__top {
    position: relative;
    margin: 0 $space-030;

    @include tablet {
      margin: 0 $space-040;
    }
  }

  &__bottom {
    display: flex;
    justify-content: space-between;
    margin: $space-040 $space-030 $space-050;
    padding-bottom: $space-020;

    @include tablet {
      margin: 0 $space-040;
      padding: $space-050 0 $space-050;
    }

    &--right {
      display: flex;
      right: 0;
    }

    &--left {
      display: flex;
    }
  }
}

.portrait-view {
  @include mobile {
    .play-bar__bottom {
      margin-bottom: $space-020;
    }
  }
}
</style>
